// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"af07a6e6","988":"19bf524c"}[chunkId] + ".chunk.js";
};